/**
 * Helper functions for dashboard navigation paths
 */
import { pages } from '../../utils/common';

export const getDashboardNavigationPaths = () => ({
  // Finance navigation paths
  finance: {
    list: pages.finance?.path ? `${pages.finance.path}/finance-list` : '/finance/finance-list',
    reports: pages.finance?.path ? `${pages.finance.path}/financial-reports` : '/finance/financial-reports',
    scholarships: pages.finance?.path ? `${pages.finance.path}/scholarships` : '/finance/scholarships',
  },
  // Students navigation paths
  students: {
    list: pages.students?.path ? `${pages.students.path}/student-list` : '/students/student-list',
    attendance: pages.students?.path ? `${pages.students.path}/attendance` : '/students/attendance',
    fees: pages.students?.path ? `${pages.students.path}/fees` : '/students/fees',
    events: pages.students?.path ? `${pages.students.path}/events` : '/students/events',
  },
  // Staff navigation paths
  staff: {
    list: pages.staff?.path ? `${pages.staff.path}/staff-list` : '/staff/staff-list',
    attendance: pages.staff?.path ? `${pages.staff.path}/attendance` : '/staff/attendance',
    payouts: pages.staff?.path ? `${pages.staff.path}/payouts` : '/staff/payouts',
    events: pages.staff?.path ? `${pages.staff.path}/events` : '/staff/events',
  },
  // Events navigation paths
  events: {
    list: pages.communications?.path ? `${pages.communications.path}/events` : '/communications/events',
    meetings: pages.communications?.path ? `${pages.communications.path}/meetings` : '/communications/meetings',
  },
});

/**
 * Generate default navigation paths for action items
 */
export const generateFinanceNavigationPath = (
  type: 'overdue' | 'partial' | 'failed_payment' | 'refund_request',
  entityId?: string
): string => {
  const paths = getDashboardNavigationPaths();
  
  switch (type) {
    case 'overdue':
    case 'partial':
      return paths.finance.list;
    case 'failed_payment':
    case 'refund_request':
      return paths.finance.reports;
    default:
      return paths.finance.list;
  }
};

export const generatePeopleNavigationPath = (
  type: 'attendance_missing' | 'unexcused_absence' | 'leave_request' | 'document_expired' | 'health_record_missing',
  entityType: 'student' | 'staff',
  entityId?: string
): string => {
  const paths = getDashboardNavigationPaths();
  
  if (entityType === 'student') {
    switch (type) {
      case 'attendance_missing':
      case 'unexcused_absence':
        return paths.students.attendance;
      case 'leave_request':
        return paths.students.list;
      default:
        return paths.students.list;
    }
  } else {
    switch (type) {
      case 'attendance_missing':
      case 'unexcused_absence':
        return paths.staff.attendance;
      case 'leave_request':
        return paths.staff.list;
      default:
        return paths.staff.list;
    }
  }
};

export const generateEventsNavigationPath = (
  type: 'event_today' | 'setup_pending' | 'approval_request' | 'followup_pending',
  eventId?: string
): string => {
  const paths = getDashboardNavigationPaths();
  return paths.events.list;
};
